import {FormGroup} from '@angular/forms';

export function NotMustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        if (matchingControl.errors && !matchingControl.errors.notmustMatch) {
            // return if another validator has already found an error on the matchingControl
            return;
        }

        if(control.value === '' && matchingControl.value === '') {
            return;
        }

        // set error on matchingControl if validation fails
        if (control.value === matchingControl.value) {
            matchingControl.setErrors({notmustMatch: true});
        } else {
            matchingControl.setErrors(null);
        }
    };
}
